var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
        _vm.paymentMethod.driver === 'wallet' &&
        _vm.paymentMethod.source &&
        _vm.paymentMethod.source.types &&
        _vm.paymentMethod.source.types.length > 0
    )?_c('WalletIcons',{attrs:{"position":"left","small":_vm.small,"wallet":_vm.paymentMethod.source}}):(_vm.icon)?_c(("icon-" + _vm.icon),{tag:"component",attrs:{"width":_vm.size,"height":_vm.size}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }